<template>
  <div class="item-drop" :class="{'setColor':activeColor}" @click="handleClick()">
    <div class="title-drop">
        <span>
            <slot name="label"></slot>
        </span>
        <i class="fa fa-chevron-down icon"></i>
    </div>
    <div class="content">
        <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
    name: 'DropdowAssurancePage.vue',
    props: {
        activeBg: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        activeColor() {
            return this.activeBg
        }
    },
    methods: {
        handleClick() {
            let el = this.$el.classList;
            el.contains('active') ? el.remove('active'): el.add('active')
        }
    }
}
</script>

<style scoped>
.item-drop {
    /* padding: 15px; */
    /* border: 1px solid red; */
    border-radius: 10px;
    /* max-width: 400px; */
    background-color: #fff;
    cursor: pointer;
    margin-bottom: 10px;
}
.setColor{
    background-color: #ffa409;
    color: #fff;
}
.title-drop {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    font-weight: 700;
    padding: 15px;
}
.content {
    height: 0;
    overflow: hidden;
    padding-top: 0;
    background-color: #fff;
    color: #000;
    border-radius:0 0 10px 10px ;
}
.active .content {
    height: auto;
    font-weight: 500;
    padding: 15px;
    transition: height 1s ;
} 
.icon {
    transition: transform 0.5s ;
}
.active .icon {
    transform: rotate(180deg);
    transition-duration: 0.5s;
}
</style>